import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

const OTPInput = ({ currentJob, otpInput, setOtpInput, onSubmit, loading }) => {
  if (!currentJob) return null;

  return (
    <div className="max-w-md mx-auto space-y-4 pt-6">
      <div className="bg-secondary rounded-lg p-6">
        <div className="text-left space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Document:</span>
            <span className="font-medium">{currentJob.document_name}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Pages:</span>
            <span className="font-medium">{currentJob.total_pages}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Cost:</span>
            <span className="font-bold text-accent">₹{currentJob.cost}</span>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-lg">Enter OTP</Label>
        <Input
          type="text"
          maxLength="4"
          placeholder="****"
          value={otpInput}
          onChange={(e) => setOtpInput(e.target.value.replace(/\D/g, ''))}
          className="text-center text-4xl font-mono tracking-widest h-20"
          data-testid="kiosk-otp-input"
        />
      </div>

      <Button
        size="lg"
        className="w-full btn-primary text-xl h-16"
        onClick={onSubmit}
        disabled={loading || otpInput.length !== 4}
        data-testid="kiosk-print-btn"
      >
        {loading ? 'Starting...' : 'Start Printing'}
      </Button>
    </div>
  );
};

export default OTPInput;
